/**
 * 実行環境の標準 API(ブラウザ・Node 20+・Cloud Functions のどれにもある)を型付きで取り出す。
 *
 * このパッケージは DOM も Node の型も読まない(tsconfig は ES2022 のみ)ので、
 * 使う分だけを最小の形で宣言する。Node の `crypto` モジュールは import しない(ブラウザで動かすため)。
 */

interface MinimalTextEncoder {
  encode(input: string): Uint8Array;
}

interface MinimalSubtleCrypto {
  digest(algorithm: string, data: Uint8Array): Promise<ArrayBuffer>;
}

interface PlatformGlobals {
  readonly TextEncoder: new () => MinimalTextEncoder;
  readonly crypto?: { readonly subtle?: MinimalSubtleCrypto };
}

const platform = globalThis as unknown as PlatformGlobals;

const encoder = new platform.TextEncoder();

/** 文字列 → UTF-8 バイト列。 */
export function utf8Bytes(text: string): Uint8Array {
  return encoder.encode(text);
}

/** UTF-8 バイト数。 */
export function utf8Length(text: string): number {
  return encoder.encode(text).length;
}

/** sha256 の16進(小文字)。Web Crypto(`globalThis.crypto.subtle`)で計算する。 */
export async function sha256Hex(text: string): Promise<string> {
  const subtle = platform.crypto?.subtle;
  if (subtle === undefined) {
    throw new Error('Web Crypto(globalThis.crypto.subtle)が使えない環境です');
  }
  const digest = new Uint8Array(await subtle.digest('SHA-256', utf8Bytes(text)));
  let hex = '';
  for (const byte of digest) hex += byte.toString(16).padStart(2, '0');
  return hex;
}
